/* eslint-disable import/no-unresolved */
import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';
import 'swiper/css/pagination';

import { Pagination } from 'swiper';

import { caseStudies } from '../constants/caseStudies';
import { development, tick } from '../assets';

const CaseStudyPage = () => {
  const { id } = useParams();
  const project = caseStudies.find((cs) => cs.id === id);
  const otherProjects = caseStudies.filter((cs) => cs.id !== id);

  return (
    <section className="pt-[120px]">
      <div className="wrapper pb-[80px]">
        <div className="section-title case-title dark:before:bg-primaryOrange/25">
          <h2 className="relative text-primaryBlack dark:text-white text-[36px] md:text-[67px] leading-[50px] md:leading-[86px] font-extrabold md:font-bold">
            Case Study
          </h2>
        </div>
      </div>
      <div className="flex flex-col xl:flex-row">
        <div className="w-full xl:w-[50%] mr-0 xl:mr-[5%] pl-[5%] xl:pl-[2.5%] pr-[5%] xl:pr-0 flex justify-start xl:justify-end">
          <div className="w-full xl:w-[625px] pt-6">
            <h3
              className={`text-[32px] md:text-[40px] font-bold ${project?.textColor} pb-3 uppercase`}
            >
              {project?.title}
            </h3>
            <p className="text-primaryBlack dark:text-white text-base leading-8">
              {project?.description}
            </p>
            <div className="bg-lightGray dark:bg-black3 rounded-lg border border-gray2 dark:border-black4 mt-8">
              <div className="border-b border-gray2 dark:border-black4 px-4 min-h-[60px] flex items-center">
                <p className="uppercase text-primaryBlack dark:text-white text-sm font-bold w-[120px]">
                  My Role
                </p>
                <p className="text-primaryBlack dark:text-white text-base">
                  {project?.role}
                </p>
              </div>
              <div className="border-b border-gray2 dark:border-black4 px-4 py-2 min-h-[60px] flex items-center">
                <p className="uppercase text-primaryBlack dark:text-white text-sm font-bold w-[120px]">
                  Tech Stack
                </p>
                <div className="flex flex-wrap gap-4">
                  {project?.tech.map((t) => (
                    <div
                      key={t.id}
                      className="rounded-full w-10 h-10 p-[6px] bg-lightGray
                      dark:bg-black4/80 shadow-[inset_0_-2px_4px_rgba(0,0,0,0.1)]"
                    >
                      <img src={t.icon} alt={t.name} />
                    </div>
                  ))}
                </div>
              </div>
              <div className="px-4 min-h-[60px] flex items-center">
                <p className="uppercase text-primaryBlack dark:text-white text-sm font-bold w-[120px]">
                  Live Demo
                </p>
                <a
                  href={`${project?.demoLink}`}
                  target="_blank"
                  className={`text-primaryBlack ${project?.hoverColor} dark:text-white text-base font-bold flex gap-3 items-center leading-5`}
                  rel="noreferrer"
                >
                  Demo Site
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="w-full xl:w-[45%] flex justify-end mt-10 xl:mt-0 pl-[2.5%] xl:pl-0">
          <img src={project?.heroAsset} alt="top" />
        </div>
      </div>

      <div className="bg-lightGray dark:bg-black3 flex flex-col xl:flex-row mt-[80px]">
        <div className="w-full xl:w-[50%] flex justify-end mr-[5%] pl-[5%] pr-[5%] xl:pr-0 py-6">
          <div className="max-w-full xl:max-w-[625px] flex flex-col justify-center">
            <h2 className="text-primaryBlack dark:text-white text-[32px] md:text-[40px] font-bold pb-8">
              Problem Statement
            </h2>
            <div className="bg-gray2 dark:bg-black4 py-8 px-6 mb-8">
              <p className="text-primaryBlack dark:text-white text-base !leading-[30px]">
                {project?.problemStatement?.problem}
              </p>
            </div>
            <p className="text-primaryBlack dark:text-white text-base !leading-[30px]">
              {project?.problemStatement?.solution}
            </p>
          </div>
        </div>
        <div className="w-full xl:w-[45%] max-h-[700px] overflow-hidden">
          <img src={project?.problemAsset} alt="problem" className="w-full" />
        </div>
      </div>

      {/* <div>
        <div className={`${project?.color} p-[50px] text-center`}>
          <h2 className="text-[28px] md:text-[32px] font-extrabold text-white">
            HIGH-FIDELITY FIGMA DESIGN
          </h2>
        </div>
        <div className="max-h-[750px] overflow-hidden">
          <img src={project?.figmaDesign} alt="jobitFigma" className="w-full" />
        </div>
      </div> */}

      <div className="wrapper py-[100px]">
        <h2 className="text-primaryBlack dark:text-white text-[32px] md:text-[40px] font-bold pb-8">
          Development Process
        </h2>
        <img src={development} alt="process" className="mx-auto" />
        {/* <p className="text-primaryGray dark:text-white text-sm font-bold text-center pt-10">
          AGILE METHODOLOGY
        </p> */}
        <p className="text-primaryBlack dark:text-white text-base !leading-[25px] pb-8 pt-9">
          {project?.processOverview}
        </p>

        <p className="text-primaryBlack dark:text-white text-base !leading-[25px] pb-3">
          The following are the deliverables and steps i took to develop the
          application:
        </p>
        <ul className="flex flex-col gap-4">
          <li>
            <p className="text-primaryBlack dark:text-white text-base !leading-[25px] font-bold">
              Definition -{' '}
              <span className="font-normal">{project?.definition}</span>
            </p>
          </li>
          <li>
            <p className="text-primaryBlack dark:text-white text-base !leading-[25px] font-bold">
              Planning -{' '}
              <span className="font-normal">{project?.planning}</span>
            </p>
          </li>
          <li>
            <p className="text-primaryBlack dark:text-white text-base !leading-[25px] font-bold">
              Development -{' '}
              <span className="font-normal">{project?.development}</span>
            </p>
          </li>
          <li>
            <p className="text-primaryBlack dark:text-white text-base !leading-[25px] font-bold">
              Delivery -{' '}
              <span className="font-normal">{project?.delivery}</span>
            </p>
          </li>
        </ul>
      </div>

      <div>
        <div className="wrapper">
          <h2 className="text-PrimaryBlack dark:text-white text-[32px] md:text-[40px] font-bold pb-8">
            Product
          </h2>
          <div className="case-container">
            <Swiper
              centeredSlides
              slidesPerView="auto"
              className="swiper_container"
              pagination={{ el: '.swiper-pagination', clickable: true }}
              modules={[Pagination]}
            >
              {project?.product.map((p) => (
                <SwiperSlide key={p.id}>
                  <img
                    src={p.asset}
                    alt="slide1"
                    className="max-w-full md:max-w-[900px] mx-auto"
                  />
                </SwiperSlide>
              ))}
              <div className="slider-controler">
                <div className="swiper-pagination" />
              </div>
            </Swiper>
          </div>

          <div className="flex justify-center mt-2">
            <a
              href={`${project?.demoLink}`}
              target="_blank"
              className={`text-PrimaryBlack dark:text-white ${project?.hoverColor} text-base font-bold flex gap-3 items-center leading-5`}
              rel="noreferrer"
            >
              See Demo Site
            </a>
          </div>
        </div>
      </div>

      <div className="wrapper py-[100px]">
        <h2 className="text-primaryBlack dark:text-white text-[32px] md:text-[40px] font-bold pb-8">
          Takeaways
        </h2>
        <div className="flex flex-col lg:flex-row justify-between gap-10">
          <div className="bg-[#F7FBF8] dark:bg-black3 p-6 pt-8 w-full lg:w-[48%]">
            <h3 className="text-[#16A34A] uppercase text-sm font-semibold pb-6">
              Learnings
            </h3>
            <ul>
              {project?.learnings.map((learning) => (
                <li
                  key={learning.id}
                  className="text-primaryBlack dark:text-white text-base pb-6 pl-[27px]"
                  style={{
                    backgroundImage: `url(${tick})`,
                    backgroundPosition: 'top 5px left',
                    backgroundRepeat: 'no-repeat',
                  }}
                >
                  {learning.item}
                </li>
              ))}
            </ul>
          </div>

          <div className="bg-[#FFF8F6] dark:bg-black3 p-6 pt-8 w-full lg:w-[48%]">
            <h3 className="text-[#DE4C36] uppercase text-sm font-semibold pb-6">
              Challenges
            </h3>
            <p className="text-primaryBlack dark:text-white text-base pb-8 !leading-7">
              {project?.challenges}
            </p>
          </div>
        </div>
      </div>

      <div className="flex justify-center py-8">
        <Link
          to="/contact"
          type="button"
          className="button w-[200px] text-center !text-lg"
        >
          Get In Touch
        </Link>
      </div>

      {otherProjects.length > 0 && (
        <div className="bg-lightGray dark:bg-black3">
          <div className="wrapper py-[80px]">
            <h2 className="text-primaryBlack dark:text-white text-[32px] md:text-[40px] font-bold pb-6">
              Other Case Studies
            </h2>
            <div className="flex flex-col md:flex-row gap-[25px]">
              {otherProjects.map((other) => (
                <div
                  key={other.id}
                  className="bg-white dark:bg-black2 max-w-full md:max-w-[400px] p-4 pb-6 flex flex-col rounded-xl
              shadow-[0px_10px_15px_-3px_rgba(0,0,0,0.1),0px_4px_6px_-4px_rgba(0,0,0,0.1)]"
                >
                  <img src={other?.figmaDesign} alt="case-study" />
                  <h4 className="text-primaryBlack dark:text-white text-xl md:text-2xl font-semibold pt-8">
                    {other?.title}
                  </h4>
                  <p className="text-primaryGray dark:text-white text-sm md:text-base pt-2 pb-6">
                    {other?.description.substring(0, 100)}...
                  </p>
                  <Link
                    to={`/case-study/${other.id}`}
                    className="button max-w-[200px] text-center"
                    onClick={
                      () =>
                        // eslint-disable-next-line implicit-arrow-linebreak
                        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
                      /* eslint-disable-next-line react/jsx-curly-newline */
                    }
                  >
                    See Case Study
                  </Link>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default CaseStudyPage;
